import { Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useLayoutStore } from '@/store/layout.store';

export function useStudentSteps(tourGuide: Ref<{ moveNext: () => void; movePrevious: () => void } | null>) {

  const { t } = useI18n();
  const layoutStore = useLayoutStore();
  const isMobile = layoutStore.getIsMobile;

  const steps = [{
        popover: {
          side: 'top',
          align: 'start',
          nextBtnText: t('tour.welcome.next'),
          title: t('tour.welcome.title'),
          description: t('tour.welcome.description'),
          showButtons: ["next", "close"]
        },
      },
      {
        element: '.search',
        popover: {
          side: "bottom",
          align: 'start',
          nextBtnText: t('tour.common.next'),
          prevBtnText: t('tour.common.previous'),
          showButtons: ["next", "close", "previous"],
          title: t('tour.search.title'),
          description: t('tour.search.description'),
          onNextClick: () => {

            if(isMobile){
              const topbarUserMenu: HTMLElement | null = document.querySelector('.user-menu');
              if (topbarUserMenu) {
                topbarUserMenu.click();
              }
            }

            tourGuide.value.moveNext();
          },
        }
      },
      { 
        element: '.user-submenu',
        popover: {
          side: "top",
          align: 'start',
          title: t('tour.profile.title'),
          nextBtnText: t('tour.common.next'),
          prevBtnText: t('tour.common.previous'),
          showButtons: ["next", "close", "previous"],
          description: t('tour.profile.description'),
          onNextClick: () => {

            if(isMobile){
              const topbarUserMenu: HTMLElement | null = document.querySelector('.user-menu');
              if (topbarUserMenu) {
                topbarUserMenu.click();
              }
            }
  
            tourGuide.value.moveNext();
          },
          onPrevClick: () => {

            if(isMobile){
              const topbarUserMenu: HTMLElement | null = document.querySelector('.user-menu');
              if (topbarUserMenu) {
                topbarUserMenu.click();
              }
            }

            tourGuide.value.movePrevious();
          }
        }
      },
      {
        element: '#certificado',
        popover: {
          side: "right",
          align: 'start',
          title: t('tour.certificates.title'),
          nextBtnText: t('tour.common.next'),
          prevBtnText: t('tour.common.previous'),
          showButtons: ["next", "close", "previous"],
          description: t('tour.certificates.description'),
          onPrevClick: () => {
            const topbarUserMenu: HTMLElement | null = document.querySelector('.user-menu');
            if (topbarUserMenu) {
              topbarUserMenu.click();
            }
            tourGuide.value.movePrevious();
          }
        },
      },
      {
        element: '#my-courses',
        popover: {
          nextBtnText: t('tour.common.finish'),
          prevBtnText: t('tour.common.previous'),
          showButtons: ["next", "close", "previous"],
          side: "right",
          align: 'start',
          title: t('tour.courses.title'),
          description: t('tour.courses.description'),
        }
      }
  ];

  return steps;
}